/*global process*/
export const keycloakConstants = {
  KEYCLOAK_ENDPOINT: "https://auth.information.gov.kh",
  KEYCLOAK_REALM: "internal_moinfo",
  KEYCLOAK_CLIENT_ID: "moinfo-news",
  KEYCLOAK_REDIRECT_URI:
    process.env.NODE_ENV === "production"
      ? "http://admin.information.gov.kh/keycloak_redirect"
      : "http://localhost:8080/keycloak_redirect",
};
